import { styled } from '@mui/material';

import { rem, Theme } from '../../theme';
import {
    StyledSlide,
    StyledSlides,
} from '../SimpleCarousel/SimpleCarousel.styled';

export const StyledContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        .espots-carousel {
            ${StyledSlides} {
                flex-grow: 0;
            }
            
            ${StyledSlide} {
                padding-inline: ${theme.tggSpacing(rem(0.2), 0.5)};
                ${theme.breakpoints.up(1024)} {
                    padding-inline: ${theme.tggSpacing(rem(0.4), 1)};
                }
            }
            ${StyledSlide}:last-of-type {
                padding-right: ${theme.tggSpacing(0, 0)};
            }
    `}
`;
